// HorizonLayoutHint.jsx
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import HorizonLayoutHintImg from '../../img/img-horizon-layout-hint.png';

import { color } from '../style/variables.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

export const HorizonLayoutHint = () => {
  const { t } = useTranslation();

  return (
    <StyledHorizonLayoutHint>
      <img src={HorizonLayoutHintImg} alt="hint" />
      <HorizonLayoutHintContent>
        {t('tips_livestream_update_rotation_to_landscape_mode', {
          ns: TranslationNamespace.LIVESTREAM,
        })}
      </HorizonLayoutHintContent>
    </StyledHorizonLayoutHint>
  );
};

HorizonLayoutHint.propTypes = {};

const StyledHorizonLayoutHint = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -75%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  z-index: 2;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 ${color.neutral['0_alpha_20']};
  background: ${color.neutral[10]};

  & > img {
    width: 48px;
    height: 48px;
  }
`;

const HorizonLayoutHintContent = styled.div`
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  color: ${color.white};
`;

export default HorizonLayoutHint;
